import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// domains
export const getDomains = (params = {}) => api.get("/domains", { params }).then((r) => r.data);
export const getDomain = (id) => api.get(`/domains/${id}`).then((r) => r.data);
export const getCategories = () => api.get("/domains/categories").then((r) => r.data.categories);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);

// auth
export const apiRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const apiLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const apiLogout = () => api.post("/auth/logout").then((r) => r.data);
export const apiMe = () => api.get("/auth/me").then((r) => r.data);
export const apiGoogleSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);

// payments + wallet
export const domainCheckout = (payload) => api.post("/payments/domain/checkout", payload).then((r) => r.data);
export const topupCheckout = (payload) => api.post("/payments/topup/checkout", payload).then((r) => r.data);
export const cryptoDomainCheckout = (payload) => api.post("/payments/crypto/domain/checkout", payload).then((r) => r.data);
export const cryptoTopupCheckout = (payload) => api.post("/payments/crypto/topup/checkout", payload).then((r) => r.data);
export const paymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const walletBuy = (domain_id) => api.post("/wallet/buy", { domain_id }).then((r) => r.data);
export const walletPurchases = () => api.get("/wallet/purchases").then((r) => r.data);
export const walletActivity = () => api.get("/wallet/activity").then((r) => r.data);

// admin
export const adminCreateDomain = (payload) => api.post("/admin/domains", payload).then((r) => r.data);
export const adminUpdateDomain = (id, payload) => api.put(`/admin/domains/${id}`, payload).then((r) => r.data);
export const adminDeleteDomain = (id) => api.delete(`/admin/domains/${id}`).then((r) => r.data);
export const adminBookings = () => api.get("/admin/bookings").then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminUpdateBooking = (id, status) => api.put(`/admin/bookings/${id}`, null, { params: { status } }).then((r) => r.data);
export const adminDeleteBooking = (id) => api.delete(`/admin/bookings/${id}`).then((r) => r.data);
export const adminUsers = () => api.get("/admin/users").then((r) => r.data);
export const adminResetUserPassword = (user_id, new_password) => api.post(`/admin/users/${user_id}/reset-password`, { new_password }).then((r) => r.data);
export const adminDeleteUser = (user_id) => api.delete(`/admin/users/${user_id}`).then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const adminUpdateSettings = (payload) => api.put("/admin/settings", payload).then((r) => r.data);

export function priceToNumber(price) {
  if (!price) return null;
  const digits = String(price).replace(/[^0-9.]/g, "");
  if (!digits) return null;
  const v = parseFloat(digits);
  return v > 0 ? v : null;
}

export function formatUSD(n) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);
}
